import OrdemServicoCamposAdicionaisService from "@/services/OrdemServicoCamposAdicionaisService";

export const ordemServicoCamposAdicionais = {
  namespaced: true,
  state: {
    configuracao: null,
    presets: [],
  },
  actions: {
    getPresets() {
      return OrdemServicoCamposAdicionaisService.GetPresets().then(
        (response) => Promise.resolve(response),
        (error) => Promise.reject(error.response?.data || error)
      );
    },
    getPreset({ commit }, payload) {
      return OrdemServicoCamposAdicionaisService.GetPreset(payload).then(
        (response) => Promise.resolve(response),
        (error) => Promise.reject(error.response?.data || error)
      );
    },
    getConfiguracaoAtiva() {
      return OrdemServicoCamposAdicionaisService.GetConfiguracaoAtiva().then(
        (response) => Promise.resolve(response),
        (error) => Promise.reject(error.response?.data || error)
      );
    },
    getConfiguracoes() {
      return OrdemServicoCamposAdicionaisService.GetConfiguracoes().then(
        (response) => Promise.resolve(response),
        (error) => Promise.reject(error.response?.data || error)
      );
    },
    postConfiguracao({ commit }, payload) {
      return OrdemServicoCamposAdicionaisService.PostConfiguracao(payload).then(
        (response) => Promise.resolve(response),
        (error) => Promise.reject(error.response?.data || error)
      );
    },
    putConfiguracao({ commit }, payload) {
      return OrdemServicoCamposAdicionaisService.PutConfiguracao(payload).then(
        (response) => Promise.resolve(response),
        (error) => Promise.reject(error.response?.data || error)
      );
    },
    deleteConfiguracao({ commit }, payload) {
      return OrdemServicoCamposAdicionaisService.DeleteConfiguracao(
        payload
      ).then(
        (response) => Promise.resolve(response),
        (error) => Promise.reject(error.response?.data || error)
      );
    },
  },
  mutations: {},
};

export default ordemServicoCamposAdicionais;
